import { massUpdateActions } from 'constants/MassUpdates';
// Mass action and its related field
const SHIPMENT_RELATED = [
    { [massUpdateActions.SHIPMENT_ARRIVED]: 'arrival_date' },
    { [massUpdateActions.EDIT_ESTIMATED_ARRIVAL]: 'estimated_arrival' },
    { [massUpdateActions.EDIT_ARRIVAL]: 'arrival_date' },
    { [massUpdateActions.EDIT_DISCHARGE]: 'discharge_date' },
    { [massUpdateActions.EDIT_LAST_FREE_DAY]: 'last_free_date' },
    { [massUpdateActions.SEND_DELIVERY_ORDER]: 'carrier_email' },
    { [massUpdateActions.BULK_APPLY_ADMIN_NOTES]: 'admin_notes' },
    {
        [massUpdateActions.EDIT_ETA_TO_FINAL_RAIL_FACILITY]: 'rail_eta_final_facility',
    },
    { [massUpdateActions.EDIT_LFD_AT_RAIL_FACILITY]: 'rail_lfd_at_facility' },
    { [massUpdateActions.UPDATE_LAST_CUT]: 'last_cut_date' },
    { [massUpdateActions.UPDATE_EARLIEST_GET_EMPTY]: 'earliest_empty_date' },
    { [massUpdateActions.UPDATE_EARLIEST_RETURN]: 'earliest_return_date' },
    { [massUpdateActions.UPDATE_REVIEW_DATE]: 'review_date' },
    { [massUpdateActions.UPDATE_EMPTY_RETURN]: 'empty_returned_date' },
    {
        [massUpdateActions.UPDATE_ACCOUNTING_REVIEW_DATE]: 'accounting_review_date',
    },
    {
        [massUpdateActions.OVERRIDE_BILLING_STATUS]: 'overrideBillingStatus',
    },
    {
        [massUpdateActions.MARK_BILLING_STATUS_PENDING_REVIEW]: 'markBillingStatusPendingReview',
    },
    {
        [massUpdateActions.BULK_CLEAR_TAGS]: 'tags',
    },
    {
        [massUpdateActions.BULK_ADD_TAGS]: 'newTags',
    },
    { [massUpdateActions.BULK_ADD_REFERENCE_NUMBERS]: 'new_ref_val' },
    {
        [massUpdateActions.BULK_ADD_TERMINAL_HOLDS]: 'terminal_hold_status',
    },
    {
        [massUpdateActions.UPDATE_EMPTY_READY_FOR_PICKUP]: 'empty_ready_for_pickup',
    },
];
export const getUpdateFieldForAction = (action) => {
    const entry = SHIPMENT_RELATED.find((e) => e[action]);
    return entry ? entry[action] : null;
};
